import { IDeliveryMethod } from '../../store/query/useOrderDeliveryMethod';

export class OrderHelper {
  static getDeliveryPrice(deliveryMethod: IDeliveryMethod, orderPrice: number) {
    return deliveryMethod.price_free && orderPrice >= deliveryMethod.price_free
      ? 0
      : deliveryMethod.price;
  }
}
